import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from 'app/redux/store/store';
import { Spinner } from 'app/components/spinner';
import { theme } from 'app/theme/theme';
import { GlobalStyle } from 'app/theme/global';
import { ErrorBoundary } from 'app/components/error-boundary';
import { router } from 'app/router';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <PersistGate persistor={persistor} loading={<Spinner />}>
            <React.StrictMode>
                <ThemeProvider theme={theme}>
                    <GlobalStyle />
                    <ErrorBoundary>
                        <RouterProvider router={router} />
                    </ErrorBoundary>
                </ThemeProvider>
            </React.StrictMode>
        </PersistGate>
    </Provider>,
);
